import React from 'react';
import { Row, Col, Card, Timeline, Typography, Tag } from 'antd';
import { BookOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const Education = () => {
  const educationData = [
    {
      degree: 'Master of Science in Computer Science',
      institution: 'Yeshiva University, Katz School of Science and Health',
      period: 'Expected December 2026',
      location: 'New York, NY',
      description: 'Advanced studies in computer science with focus on enterprise systems, security, and performance optimization.',
      coursework: [
        'Enterprise System Architecture',
        'Advanced Security Protocols',
        'Performance Optimization',
        'Data Structures & Algorithms',
        'Software Engineering',
        'Zero Trust Architectures'
      ],
      achievements: [
        'Innovation Challenge Winner 2025',
        'Published research on Zero Trust Security Frameworks',
        'Active in graduate research programs'
      ]
    },
    {
      degree: 'Bachelor of Science in Software Engineering',
      institution: 'Makerere University',
      period: 'January 2019',
      location: 'Kampala, Uganda',
      description: 'Comprehensive foundation in software engineering principles, system design, and development methodologies.',
      coursework: [
        'Programming Fundamentals',
        'Data Structures and Algorithms',
        'Software Engineering',
        'Database Systems',
        'Computer Networks',
        'System Design'
      ],
      achievements: [
        'Graduated with distinction',
        'Active contributor to university tech community',
        'Led student programming competitions'
      ]
    }
  ];

  const certifications = [
    {
      name: 'AWS Cloud Practitioner',
      issuer: 'Amazon Web Services',
      date: 'In Progress',
      credential: 'AWS-CP-001'
    },
    {
      name: 'Linux Professional Institute Certification (LPIC-1)',
      issuer: 'Linux Professional Institute',
      date: 'Self-Study',
      credential: 'LPIC-1-001'
    },
    {
      name: 'Agile Software Development',
      issuer: 'Certified Scrum Master Track',
      date: 'Certified',
      credential: 'CSM-001'
    }
  ];


  const timelineItems = educationData.map((edu, index) => ({
    children: (
      <Card key={index} style={{ marginBottom: '24px' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
          <BookOutlined style={{ 
            fontSize: '24px', 
            color: '#1890ff', 
            marginTop: '4px',
            flexShrink: 0
          }} />
          <div style={{ flex: 1 }}>
            <Title level={4} style={{ marginBottom: '8px' }}>
              {edu.degree}
            </Title>
            
            <div style={{ marginBottom: '12px' }}>
              <Text strong style={{ color: '#1890ff', marginRight: '16px' }}>
                {edu.institution}
              </Text>
              <Text type="secondary">{edu.period}</Text>
              <Text type="secondary" style={{ marginLeft: '16px' }}>{edu.location}</Text>
            </div>
            
            <Paragraph style={{ marginBottom: '16px' }}>
              {edu.description}
            </Paragraph>
            
            <div style={{ marginBottom: '16px' }}>
              <Title level={5} style={{ marginBottom: '8px' }}>Key Coursework:</Title>
              <div>
                {edu.coursework.map((course, courseIndex) => (
                  <Tag key={courseIndex} color="blue" style={{ marginBottom: '4px' }}>
                    {course}
                  </Tag>
                ))}
              </div>
            </div>

            <div>
              <Title level={5} style={{ marginBottom: '8px' }}>Achievements:</Title>
              <ul style={{ paddingLeft: '20px', margin: 0 }}>
                {edu.achievements.map((achievement, achIndex) => (
                  <li key={achIndex} style={{ marginBottom: '4px' }}>
                    {achievement}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </Card>
    ),
  }));

  return (
    <section id="education" className="section section-gray">
      <div className="container">
        <div className="section-header">
          <Title level={2} className="section-title">Education & Certifications</Title>
          <Paragraph className="section-subtitle">My academic background and professional certifications</Paragraph>
        </div>

        <Row gutter={[48, 48]}>
          <Col xs={24} lg={16}>
            <div className="fade-in-up">
              <Timeline items={timelineItems} />
            </div>
          </Col>

          <Col xs={24} lg={8}>
            <div className="fade-in-up" style={{ animationDelay: '0.2s' }}>
              <Card title="Certifications">
                {certifications.map((cert, index) => (
                  <Card
                    key={index}
                    size="small"
                    style={{ marginBottom: index < certifications.length - 1 ? '16px' : 0 }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <div style={{ flex: 1 }}>
                        <Title level={5} style={{ margin: 0, marginBottom: '4px' }}>
                          {cert.name}
                        </Title>
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                          {cert.issuer}
                        </Text>
                        <br />
                        <Text type="secondary" style={{ fontSize: '11px', fontFamily: 'monospace' }}>
                          ID: {cert.credential}
                        </Text>
                      </div>
                      <Tag color="blue" style={{ marginLeft: '8px' }}>
                        {cert.date}
                      </Tag>
                    </div>
                  </Card>
                ))}
              </Card>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default Education;